import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=6b133985&scoped=true&"
import script from "./ActionDialog.vue?vue&type=script&lang=ts&"
export * from "./ActionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ActionDialog.vue?vue&type=style&index=0&id=6b133985&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b133985",
  null
  
)

export default component.exports